<template>
    <section class="py-12 bg-white lg:py-16" :class="newStyle ? 'md-max:pt-0' : ''">
        <div class="px-4 mx-auto max-w-screen-2xl sm:px-6 lg:px-8 xl:px-16">
            <div class="mb-12 text-center md:mb-16">
                <h2 :class="newStyle ? 'xl:text-4xl text-3xl' : 'md:text-3xl xl:text-4xl text-2xl'"
                    class="font-bold leading-tight text-black font-ww-bold" v-html="title">
                </h2>
            </div>

            <div class="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-5">
                <div v-for="(feature, index) in features" :key="index" class="flex flex-col items-center text-center"
                    :class="index === 4 ? 'md-max:col-span-2' : ''">
                    <div :class="newStyle ? 'flex justify-center items-center mb-6 w-24 h-24 lg:w-24 lg:h-24 md:w-20 md:h-20 rounded-full bg-[#F3EFE3]' : 'flex justify-center items-center mb-6 w-16 h-16 lg:w-24 lg:h-24 md:w-20 md:h-20 rounded-full bg-[#F3EFE3]'"
                        class="">
                        <nuxt-img :class="newStyle ? '' : 'md-max:w-10'" :src="feature.icon" :alt="feature.text"
                            class="object-contain" loading="lazy" format="webp"
                            sizes="xs:32px sm:32px md:32px lg:48px xl:48px" :width="feature.width"
                            :height="feature.height" />
                    </div>
                    <div :class="newStyle ? 'text-19 md:text-left text-center md:px-0 px-2' : 'xl:text-19 md:text-lg text-base text-center'"
                        class="leading-tight text-black font-ww-medium max-w-52" v-html="feature.text">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    newStyle: { type: Boolean, default: false },
    title: {
        type: String,
        default: 'What Makes Our Coffee Different?'
    },
    features: {
        type: Array,
        default: () => [
            {
                icon: '/assets/images/bogo-acidic.svg',
                text: '<strong>27.7% Less Acidic</strong><br>than store-bought<br>coffee (pH tested)',
                width: 48,
                height: 48
            },
            {
                icon: '/assets/images/bogo-tested.svg',
                text: '<strong>Tested for<br>450+ Toxins</strong>',
                width: 64,
                height: 61
            },
            {
                icon: '/assets/images/bogo-single-origin.svg',
                text: '<strong>Single-Origin</strong> from small farms in Central America',
                width: 57,
                height: 52
            },
            {
                icon: '/assets/images/bogo-trustpure.svg',
                text: '<strong>TrustPure Process curates only 3% ofSpecialty Grade</strong> beans.',
                width: 52,
                height: 51
            },
            {
                icon: '/assets/images/bogo-shade-Grown.svg',
                text: '<strong>Shade-Grown &<br>Sun-Dried</strong> at high<br>elevation',
                width: 59,
                height: 47
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'Icon Feature Highlights Row',
    inputs: [
        {
            name: 'newStyle',
            type: 'boolean',
            defaultValue: false,
            friendlyName: 'New Style'
        },
        {
            name: 'title',
            type: 'text',
            defaultValue: 'What Makes Our Coffee Different?',
            friendlyName: 'Section Title'
        },
        {
            name: 'features',
            type: 'list',
            friendlyName: 'Features List',
            defaultValue: [
                {
                    icon: '/assets/images/bogo-acidic.svg',
                    text: '<strong>27.7% Less Acidic</strong><br>than store-bought<br>coffee (pH tested)',
                    width: 48,
                    height: 48
                },
                {
                    icon: '/assets/images/bogo-tested.svg',
                    text: '<strong>Tested for<br>450+ Toxins</strong>',
                    width: 64,
                    height: 61
                },
                {
                    icon: '/assets/images/bogo-single-origin.svg',
                    text: '<strong>Single-Origin</strong> from small farms in Central America',
                    width: 57,
                    height: 52
                },
                {
                    icon: '/assets/images/bogo-trustpure.svg',
                    text: '<strong>TrustPure Process curates only 3% ofSpecialty Grade</strong> beans.',
                    width: 52,
                    height: 51
                },
                {
                    icon: '/assets/images/bogo-shade-Grown.svg',
                    text: '<strong>Shade-Grown &<br>Sun-Dried</strong> at high<br>elevation',
                    width: 59,
                    height: 47
                }
            ],
            subFields: [
                {
                    name: 'icon',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    required: true,
                    friendlyName: 'Icon'
                },
                {
                    name: 'text',
                    type: 'richText',
                    defaultValue: '<strong>Feature Title</strong><br>Feature Description',
                    friendlyName: 'Text content'
                },
                {
                    name: 'width',
                    type: 'number',
                    defaultValue: 48,
                    friendlyName: 'Width'
                },
                {
                    name: 'height',
                    type: 'number',
                    defaultValue: 48,
                    friendlyName: 'Height'
                }
            ]
        }
    ]
});
</script>
